import { CoreInput } from '@/components/Form/InputAntForm';
import CoreSelect from '@/components/Form/SelectAntForm';
import { useHandleActionItem } from '@/components/hooks/useHandleActionItem';
import { useCoreContext, useOpacity } from '@/core';
import { CenterEntity } from '@/domains/center/entities';
import { EditOutlined, FilterOutlined, SearchOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import { ColumnsType, ColumnType } from 'antd/lib/table';
import { get } from 'lodash';
import React from 'react';

export const CenterTableColumns = () => {
  const { control } = useCoreContext();
  const { opacity, setOpacity } = useOpacity();
  const { handleClickEdit } = useHandleActionItem();

  const optionsStatus = [
    {
      value: true,
      label: 'ACTIVE',
    },
    {
      value: false,
      label: 'INACTIVE',
    },
  ];

  const getColumnSearchProps = (field: 'search' | 'shortName'): ColumnType<CenterEntity> => ({
    filterDropdown: () => (
      <div style={{ padding: 8, width: '200px' }} onKeyDown={(e) => e.stopPropagation()}>
        <CoreInput control={control} name={field} />
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <>
        <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
      </>
    ),
  });

  const getColumnStatusProps = (): ColumnType<CenterEntity> => ({
    filterDropdown: () => (
      <div style={{ padding: 8, width: '200px' }} onKeyDown={(e) => e.stopPropagation()}>
        <CoreSelect control={control} name='isActive' optionsProps={optionsStatus} />
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <>
        <FilterOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
      </>
    ),
  });

  const tableColumns: ColumnsType<CenterEntity> = [
    {
      title: 'shortName',
      dataIndex: 'shortName',
      key: 'shortName',
      width: '100px',
      ...getColumnSearchProps('shortName'),
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      width: '150px',
      ...getColumnSearchProps('search'),
    },
    {
      title: 'hotLine',
      dataIndex: 'hotLine',
      key: 'hotLine',
      width: '150px',
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      width: '150px',
    },
    {
      title: 'Address',
      dataIndex: 'address',
      key: 'address',
      width: '200px',
      render: (record: any) => {
        if (record) {
          const address = get(record, 'address');
          const ward = get(record, 'ward.name');
          const district = get(record, 'district.name');
          const city = get(record, 'city.name');
          const country = get(record, 'country.name');
          const array = [address, ward, district, city, country];
          return array.filter((item) => !!item).join(',' + ' ');
        }
        return null;
      },
    },
    {
      title: 'Status',
      dataIndex: 'isActive',
      key: 'status',
      width: ' 100px',
      render: (value: boolean) => {
        if (value === true) {
          return <Typography.Text type='success'>Active</Typography.Text>;
        }
        return <Typography.Text disabled>Deactivated</Typography.Text>;
      },
      ...getColumnStatusProps(),
    },
    {
      title: 'Action',
      width: '6rem',
      key: 'action',
      render: (record: any) => {
        return (
          <div
            className='actions'
            onMouseOver={() => setOpacity(1)}
            onMouseLeave={() => setOpacity(0.6)}
          >
            <EditOutlined
              style={{ color: 'blue', cursor: 'pointer', opacity }}
              onClick={() => handleClickEdit(record)}
            />
          </div>
        );
      },
      fixed: 'right',
    },
  ];

  return tableColumns;
};
